export default __webpack_public_path__ + "static/media/navigationLeft.d6e57cd3.svg";